import { actionTypes as playerActionTypes } from "../actions";
import { ACTION_TYPES } from "./actions";

const initialState = "";

const playSource = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.SET_PLAY_SOURCE:
      return payload;
    case playerActionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};

export default playSource;
